import { Button, Collapse, Row, theme, Typography } from "antd";
import dayjs from "dayjs";
import investServices from "@/services/apiServices/investServices/index.js";
import { CaretRightOutlined, SwapRightOutlined } from "@ant-design/icons";
import CustomTable from "@/components/CustomTable/index.jsx";
import useSWR from "swr";
import ChartCard from "@/components/ChartCard/index.jsx";

const AnalysisByVOO = ({ graphData, submitPortfolio, isPortfolioLoading }) => {
  const { token } = theme.useToken();
  const panelStyle = {
    border: "none",
  };

  const {
    data: historyData,
    isLoading: isHistoryDataLoading,
    mutate: mutateVOOData,
  } = useSWR(`fetchCompareTradesHistory`, investServices.getCompareTrades);

  const historyHeaders = [
    {
      title: "Runtime",
      dataIndex: "created_on",
      render: (value) => dayjs(value)?.format("HH:mm DD/MM/YYYY"),
    },
    {
      title: "Parameters",
      dataIndex: "id",
      render: (_, record) => (
        <Row className="items-center">
          <span>
            {record?.start_date} <SwapRightOutlined /> {record?.end_date}
          </span>
          <span className="mx-2">|</span>
          <span>{record?.files?.[0]?.spreadsheet_url}</span>
        </Row>
      ),
    },
    {
      title: "View",
      dataIndex: "id",
      render: (_, record) => (
        <Button
          type="link"
          href={record?.files?.[0]?.spreadsheet_url}
          target={"_blank"}
          className="p-0 m-0"
        >
          open
        </Button>
      ),
    },
  ];

  const lineChartConfig = {
    data: graphData || [],
    xField: "date",
    yField: "value",
    colorField: "category",
  };

  const getItems = (panelStyle) => [
    {
      key: "1",
      label: (
        <Typography.Text className="text-[16px] font-semibold mb-[20px]">
          History
        </Typography.Text>
      ),
      children: (
        <Row className="w-full flex-col">
          <CustomTable
            isTableLoading={isHistoryDataLoading}
            tableHeaders={historyHeaders}
            tableData={historyData?.data?.data || []}
            onRowClick={() => {}}
          />
        </Row>
      ),
      style: panelStyle,
    },
    {
      key: "2",
      label: (
        <Typography.Text className="text-[16px] font-semibold mb-[20px]">
          Monthly Portfolio Performance - Line chart of realARR vs altARR
        </Typography.Text>
      ),
      children: (
        <Row className="w-full flex-col">
          <ChartCard chartConfig={lineChartConfig} chartType={"LINE"} />
        </Row>
      ),
      style: panelStyle,
    },
  ];

  return (
    <>
      <Button
        type="primary"
        className="mr-4 bg-primaryDark"
        onClick={async () => {
          await submitPortfolio("AnalysisByVOO");
          await mutateVOOData();
        }}
        loading={isPortfolioLoading}
      >
        Run
      </Button>
      <Button
        href={historyData?.data?.data?.[0]?.files?.[0]?.spreadsheet_url}
        disabled={!historyData?.data?.data?.[0]?.files?.[0]?.spreadsheet_url}
        target={"_blank"}
        className="mr-2"
      >
        Open recent execution file
      </Button>
      <Collapse
        bordered={false}
        className="mt-[20px]"
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        style={{
          background: token.colorBgContainer,
        }}
        key={graphData}
        items={getItems(panelStyle)}
      />
    </>
  );
};

export default AnalysisByVOO;
